var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAssetPlot = function SvgAssetPlot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_7000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 16C39.6 16 37.98 18.88 38.64 21.02L31.54 28.14C30.94 27.96 30.06 27.96 29.46 28.14L24.36 23.04C25.04 20.9 23.42 18 20.5 18C17.6 18 15.96 20.88 16.64 23.04L7.52 32.14C5.38 31.48 2.5 33.1 2.5 36C2.5 38.2 4.3 40 6.5 40C9.4 40 11.02 37.12 10.36 34.98L19.46 25.86C20.06 26.04 20.94 26.04 21.54 25.86L26.64 30.96C25.96 33.1 27.58 36 30.5 36C33.4 36 35.04 33.12 34.36 30.96L41.48 23.86C43.62 24.52 46.5 22.9 46.5 20C46.5 17.8 44.7 16 42.5 16Z",
    fill: "#4F43DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 18L32.38 13.86L36.5 12L32.38 10.14L30.5 6L28.66 10.14L24.5 12L28.66 13.86L30.5 18Z",
    fill: "#4F43DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22L8.5 18L12.5 17L8.5 16L7.5 12L6.5 16L2.5 17L6.5 18L7.5 22Z",
    fill: "#4F43DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_7000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAssetPlot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/asset_plot.06d8855959d1a55dfd189120698be6eb.svg";